var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinearEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_edit",
    "data-name": "vuesax/linear/edit",
    transform: "translate(-620 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(620 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.745,0h-1.5C1.5,0,0,1.5,0,5.246v4.5c0,3.747,1.5,5.246,5.246,5.246h4.5c3.747,0,5.246-1.5,5.246-5.246v-1.5",
    transform: "translate(1.506 1.506)",
    fill: "none",
    stroke: "#d3ff9a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M6.769.957.836,6.89a2.042,2.042,0,0,0-.5.994L.016,10.15A1.072,1.072,0,0,0,1.3,11.43l2.266-.324a2.109,2.109,0,0,0,.994-.5l5.933-5.933c1.024-1.024,1.506-2.213,0-3.719S7.793-.067,6.769.957Z",
    transform: "translate(5.238 1.317)",
    fill: "none",
    stroke: "#d3ff9a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0A5.379,5.379,0,0,0,3.719,3.719",
    transform: "translate(11.171 3.109)",
    fill: "none",
    stroke: "#d3ff9a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H18V18H0Z",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinearEdit);
export default __webpack_public_path__ + "static/media/linear-edit.ce53170d4ca960dcb6d1cf5b9d367be9.svg";
export { ForwardRef as ReactComponent };